module.exports = __webpack_public_path__ + "static/media/background-706.a19d6f1e.png";